import { Output, EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GraphqlService } from '../../services/graphql.service';
import { CommonDataService } from '../../services/common-data.service';
import { LoginService } from '../../services/Login.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { constObj } from '../../Constants/constants';
import { HttpcallService } from '../../services/httpcall.service';

@Component({
  selector: 'app-bookmark',
  templateUrl: './bookmark.component.html'
})
export class BookmarkComponent implements OnInit {
  @Output() myEvent = new EventEmitter<string>();
  addBookmarkLabel: any;
  bookmarkingLabel: any;
  addBookmarktitle: any;
  cancelButtonLabel: any;
  bookmarksubmit: any;
  userId: string;
  mailId: string;
  currentParagraph: string;
  todayDate: Date = new Date();

  constructor(private graphQlService: GraphqlService, private loginService: LoginService,
    private httpCallService: HttpcallService,
    public commonDataService: CommonDataService, private datePipe: DatePipe,private router:Router) {

  }

  bookmarkBreadcrumbPath: string = "";
  bookmarkTitle = new FormControl('');
  pageNums: string = "";
  pageUrl: string = "";
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.commonDataService.currentParagraph.subscribe(data1 => {
      this.currentParagraph = data1;
    });
    this.commonDataService.pageUrl.subscribe(data3 => { this.pageUrl = data3; })
    this.commonDataService.breadcrumbPath.subscribe(path => {
      this.breadcrumbPath = path;
      this.pageNums = "";
      let crumbData = this.breadcrumbPath.split("~");
      this.bookmarkBreadcrumbPath = crumbData[0] + "~";
      for (let i = 1; i < crumbData.length; i++) {
        if (!crumbData[i].split(" ")[0].includes("X")) {
          this.commonDataService.currentParagraphId.subscribe(data => {
            if (data != "" && data != null) {
              this.pageNums = (data.replace("SafeValue must use [property]=binding: ", "")).replace(" (see https://g.co/ng/security#xss)", "");
            }
          })
          this.bookmarkBreadcrumbPath += (i != crumbData.length - 1 ? crumbData[i] + "~" : crumbData[i])
        }
      }
      if (this.pageNums != '' && this.pageNums != null)
        this.bookmarkBreadcrumbPath += "~" + this.pageNums
    });
    this.getbookmarkLabel();

    this.commonDataService.userId.subscribe(userData => this.userId = userData);
    this.commonDataService.mailId.subscribe(mailId => this.mailId = mailId);
  }

  closeOverlay() {
    this.myEvent.emit();
    this.commonDataService.showLoader.next(false);
  }
  getbookmarkLabel() {
    this.graphQlService.getGlobalLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.addBookmarkLabel = labels.filter(x => x.key == "addBookmark_header").map(y => y.value);
        this.bookmarkingLabel = labels.filter(x => x.key == "addBookmark_subtext").map(y => y.value);
        this.addBookmarktitle = labels.filter(x => x.key == "addBookmark_title").map(y => y.value);
        this.cancelButtonLabel = labels.filter(x => x.key == "global_cancel").map(y => y.value);
        this.bookmarksubmit = labels.filter(x => x.key == "global_add").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    });
  }

  breadcrumbPath: string = "";
  Submit() {
    this.commonDataService.showLoader.next(true);
    if (this.bookmarkBreadcrumbPath !== "") {
            var bookmark = {
              ID: '-1', TopicId: 'topic1', ParagraphId: this.currentParagraph, BookmarkTitle: this.bookmarkTitle.value, BookMarkBreadCrumb: this.bookmarkBreadcrumbPath, IsDeleted: false, CreatedOn: "", ModifiedOn: "", ApplicationSource: "GARS",
              BookmarkURL: this.router.url.includes("showallinonepage") ? "/" + this.pageUrl : this.router.url + "/" + this.currentParagraph, NavigationPath:"GARS"
            }
            this.httpCall(bookmark)
        }
  }
  httpCall(bookmark) {
    this.httpCallService.addUpdateBookmark(bookmark).toPromise()
      .then(response => {
        if (response == "Bookmark added successfully") {
          this.commonDataService.addBookmarkParagraphId.next(bookmark.ParagraphId);
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.bookmarkAddedMessage
          }
          this.commonDataService.notificationObject.next(obj);
          this.closeOverlay();
        }
        else if (response == "Session expired") {
          let obj = {
            type: 'error',
            displayTime: 3000,
            position: 'bottom',
            message: "You are not authorized , please log in"
          }
          this.commonDataService.notificationObject.next(obj);
          this.closeOverlay();
          this.router.navigate(['Login'])
        }
        else {
          let obj = {
            type: 'error',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.bookmarkAddedFailMessage
          }
          this.commonDataService.notificationObject.next(obj);
          this.closeOverlay();
        }
      })
      .catch(res => {
        console.log(res);
      });
  }


  remainingText: number = 0;
  
  BookMarkTitleModified(value: string) {
    this.remainingText = 100 - value.length;
  }
}
